import React, { useState, useEffect } from 'react';
import { MdClear } from 'react-icons/md';

// TODO: Fix dismiss and then rethrowing error. Current state: NOT working
const Alert = ({ isVisible = false, children, className }) => {
  const [visible, setVisible] = useState(isVisible);

  useEffect(() => {
    setVisible(isVisible);
  }, [isVisible]);

  const toggle = () => setVisible((v) => !v);

  if (!visible) return null;

  return (
    <div className={className}>
      {children}
      <button className="alert__dismiss" type="button" onClick={toggle}>
        <MdClear />
      </button>
    </div>
  );
};

export default Alert;
